module.exports = __webpack_public_path__ + "img/saba_safsal_no.19615492.png";